import { render, staticRenderFns } from "./dataImport.vue?vue&type=template&id=14207f02&scoped=true"
import script from "./dataImport.vue?vue&type=script&lang=js"
export * from "./dataImport.vue?vue&type=script&lang=js"
import style0 from "./dataImport.vue?vue&type=style&index=0&id=14207f02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14207f02",
  null
  
)

export default component.exports